import { hide, show } from "@app/account/validationHelpers";

interface Config {
  showPassword: boolean;
}

$(() => {
  class Login {
    private form: HTMLFormElement = document.getElementById("login-form-full") as HTMLFormElement;
    private submitButton: HTMLButtonElement = document.getElementById("submit-button") as HTMLButtonElement;
    private userName: HTMLInputElement = document.getElementById("username") as HTMLInputElement;
    private passwordRow: HTMLElement = document.getElementById("password-row") as HTMLElement;
    private password: HTMLInputElement = document.getElementById("password") as HTMLInputElement;
    private ssoMessage: HTMLDivElement = document.getElementById("sso-message") as HTMLDivElement;
    private validationSummary: HTMLDivElement = document.getElementById("validation-summary") as HTMLDivElement;
    private rememberMe: HTMLInputElement = document.getElementById("remember-me") as HTMLInputElement;
    private forgotPassword: HTMLLIElement = document.getElementById("forgot-password") as HTMLLIElement;

    private showPassword: boolean;
    private config: Config = window.config as Config || {} as Config;

    constructor() {

      this.showPassword = this.config.showPassword;

      // if the username field has a value and we"re showing the password field, set focus to that field
      if (this.showPassword && this.userName.value) {
        this.submitButton.innerText = "Log In";
        show(this.passwordRow);
        show(this.forgotPassword);
        this.password.focus();
      } else {
        hide(this.passwordRow);
        hide(this.forgotPassword);
        this.submitButton.innerText = "Continue";
        this.userName.focus();
      }

      this.userName.addEventListener("input", this.handleUserNameInput);
      this.submitButton.addEventListener("click", this.handleSubmitButtonClick);
    }

    private handleUserNameInput = (ev: InputEvent): void => {
      if (ev.inputType == "insertFromPaste") // avoid condition that prevents the password box from being shown when redirected from SSO
        return;

      if (this.showPassword) {
        // showing password and user typed in the userName field. Hide the password and change the input button from "Login" to "Continue"
        this.password.removeAttribute("required");
        hide(this.passwordRow);
        hide(this.forgotPassword);
        this.showPassword = false;
        this.submitButton.innerText = "Continue";

        if (this.ssoMessage) {
          hide(this.ssoMessage);
        }
        if (this.validationSummary) {
          hide(this.validationSummary);
        }
      }
    }

    // Handles submit button click on the login form.
    // If only the username field is being displayed, the handler posts back to an API endpoint to get the "challenge" URL for the client,
    // if the username is valid and the client is SSO enabled. If a challenge URL is returned, the browser is directed to that URL. If not, the password field is shown.
    //
    // If the password field is being displayed, this handler does nothing.
    private handleSubmitButtonClick = (e: Event): void => {

      // only handle this event if the password field is not being shown and the username field is not empty
      if (!this.showPassword && this.userName.value) {

        e.preventDefault(); // don't allow the default behavior of the submit button here

        // get the return url, anti-forgery token, username and "remember me" value, then post back to the get challenge url endpoint
        const searchParams = new URLSearchParams(window.location.search);

        //TODO: find a better way to do this -- returnUrl has variable case and we never know which one we"re going to get
        const returnUrl = searchParams.has("ReturnUrl") ? searchParams.get("ReturnUrl") : searchParams.has("returnUrl") ? searchParams.get("returnUrl") : "";

        // get the anti-forgery token from the form
        const token = $("input[name='__RequestVerificationToken']", this.form).val().toString();

        // build the request model
        const model = {
          __RequestVerificationToken: token, // this is part of the model that we send, but not part of the model received at the controller thanks to the magic of MVC.
          rememberMe: this.rememberMe.value,
          returnUrl,
          userName: this.userName.value,
        };

        // this is intentionall a form post, not a json post (so we can use the anti-forgery token)
        const s: JQuery.UrlAjaxSettings = {
          data: model,
          success: (challengeUrl) => {
            if (challengeUrl) {
              // redirect to the SSO url
              window.location = challengeUrl;
            } else {
              // not an sso enabled client (or maybe a bad username) - show the password field and all the stuff that goes with it, then set focus to the password field
              this.showPassword = true;
              this.submitButton.innerText = "Log In";
              show(this.passwordRow);
              show(this.forgotPassword);

              this.password.focus();
            }
          },
          url: "/app/account/get-challenge-url",
        }

        $.post(s);
      }
    }
  }

  new Login();
});
